import ApiService from './api';
import { safeArray } from '../utils/money';
import { Refund } from '@/types';

export interface CreateRefundRequest {
  payment_id: string;
  amount?: number;
  reason?: string;
  metadata?: Record<string, any>;
}

export interface RefundFilters {
  status?: string;
  payment_id?: string;
  date_from?: string;
  date_to?: string;
}

export class RefundService {
  /**
   * 创建退款
   */
  static async createRefund(data: CreateRefundRequest): Promise<Refund> {
    const response = await ApiService.post<Refund>('/merchant/payments/refunds', data);
    return response.data;
  }

  /**
   * 获取退款详情
   */
  static async getRefund(id: string): Promise<Refund> {
    const response = await ApiService.get<Refund>(`/merchant/payments/refunds/${id}`);
    return response.data;
  }

  /**
   * 获取退款列表
   */
  static async listRefunds(
    page: number = 1,
    limit: number = 20,
    filters?: RefundFilters
  ): Promise<{
    data: Refund[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
    };
  }> {
    const params = { page, limit, ...filters };
    const response = await ApiService.get('/merchant/payments/refunds', params);
    return {
      data: safeArray<Refund>(response.data),
      meta: response.meta || { total: 0, per_page: 20, current_page: 1, last_page: 1 },
    };
  }
}

export default RefundService;
